import { Button, Form, FormProps, Icons, Input, Select, Space, useSelect } from "@pankod/refine-antd";
import { useOne } from "@pankod/refine-core";
import { RenderSpinner } from "components/common";
import { ILookup, IScreeningMetadata } from "interfaces";
import { arrayExtensions } from "lib-common";
import { DATAPROVIDER_LOOKUP, RESOURCE_PATH, STALE_DURATION } from "scripts/site";

export const BackgroundScreeningFilter: React.FC<{
    formProps: FormProps,
    onApplyFilter: () => void,
}> = (props) => {
    const { isLoading, data: metadata } = useOne<IScreeningMetadata>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.METADATA,
        id: RESOURCE_PATH.BACKGROUND_SCREENING,
        queryOptions: {
            enabled: true,
            staleTime: STALE_DURATION,
        },
    });

    // Select hook for country lookup
    const { selectProps: countryProps } = useSelect<ILookup>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.COUNTRY,
        optionLabel: "name",
        optionValue: "id",
        sort: [
            {
                field: "name",
                order: "asc",
            },
        ],
        fetchSize: 100,
    });

    // User select for manager (TCS Manager)
    const { selectProps: userProps } = useSelect<ILookup>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.PEOPLE,
        optionLabel: "nameEmail",
        optionValue: "id",
        filters: [
            { field: "stateManager.state", operator: "eq", value: "active" },
            { field: "id", operator: "contains", value: "@microsoft.com" },
        ],
        sort: [{ field: "lastAccessedAt", order: "desc" }],
        fetchSize: 50,
    });

    return (
        isLoading ? <RenderSpinner message="Loading..." /> :
            <Form layout="vertical" {...props.formProps} autoComplete="off">

                <Form.Item label="Associate Name" name="name">
                    <Input placeholder="Enter Associate Name" />
                </Form.Item>

                <Form.Item label="TCS Employee Id" name="tcsEmployeeId">
                    <Input placeholder="Enter TCS Employee Id" />
                </Form.Item>

                <Form.Item label="TCS Email Id" name="tcsEmailId">
                    <Input placeholder="Enter TCS Email Id" />
                </Form.Item>

                {/* TCS Manager filter */}
                <Form.Item label="TCS Manager" name="managerUserId">
                    <Select allowClear showSearch placeholder="Search Name or Email" {...userProps} />
                </Form.Item>
                <Form.Item
                    label="Request Status"
                    name="state"
                >
                    <Select
                        allowClear
                        mode="multiple"
                        placeholder="Request status"
                    >
                        {arrayExtensions.sortBy("order", metadata?.data?.states ?? [])?.map((m, i) => (
                            <Select.Option value={m.state} key={i}>{m.displayName}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label="Country" name="countryId">
                    <Select allowClear placeholder="Select Country" showSearch {...countryProps} />
                </Form.Item>

                <Form.Item label="WON" name="won">
                    <Input placeholder="Enter Work Order Number" />
                </Form.Item>

                <Form.Item>
                    <Space>
                        <Button
                            htmlType="submit"
                            type="primary"
                            icon={<Icons.FilterOutlined />}
                            onClick={() => props.onApplyFilter()}
                        >
                            Apply
                        </Button>
                        <Button
                            icon={<Icons.ClearOutlined />}
                            htmlType="submit"
                            onClick={() => props.formProps.form?.resetFields()}
                        >
                            Clear
                        </Button>
                    </Space>
                </Form.Item>

            </Form>
    );
};
